import { render, staticRenderFns } from "./InputKasMasuk.vue?vue&type=template&id=face2aa6&"
import script from "./InputKasMasuk.vue?vue&type=script&lang=js&"
export * from "./InputKasMasuk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports